module.exports = __webpack_public_path__ + "static/media/avolon.c5bd42be.png";